module.exports = __webpack_public_path__ + "static/media/how-to-cut-your-foods-climate-emissions.be1d7a57.jpg";